import {
  startAuthentication,
  startRegistration,
  WebAuthnAbortService,
} from '@simplewebauthn/browser';

export type WebAuthnCeremony<T> = { result: Promise<T>; cancel: () => void };

let cancelCurrent: (() => void) | undefined;

const invoke = <T>(start: () => Promise<T>): Promise<T> => {
  try {
    return start();
  } catch (error) {
    return Promise.reject(error);
  }
};

const startOwned = <T>(start: () => Promise<T>): WebAuthnCeremony<T> => {
  cancelCurrent?.();
  const cancel = () => {
    if (cancelCurrent !== cancel) {
      return;
    }
    cancelCurrent = undefined;
    WebAuthnAbortService.cancelCeremony();
  };
  cancelCurrent = cancel;
  const result = invoke(start).finally(() => {
    if (cancelCurrent === cancel) {
      cancelCurrent = undefined;
    }
  });
  return { result, cancel };
};

export const startOwnedAuthentication = (
  options: Parameters<typeof startAuthentication>[0],
): WebAuthnCeremony<Awaited<ReturnType<typeof startAuthentication>>> =>
  startOwned(() => startAuthentication(options));

export const startOwnedRegistration = (
  options: Parameters<typeof startRegistration>[0],
): WebAuthnCeremony<Awaited<ReturnType<typeof startRegistration>>> =>
  startOwned(() => startRegistration(options));
